/*
 *
 * PaymentsDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 25-Feb-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import Dialog from '@mui/material/Dialog'
import PortalTabs from '@nexidigital/portaltabs'
import FlowTemplate from 'Components/Template/FlowTemplate'
import FirstPeriodDetail from './FirstPeriodDetail'
import SecondPeriodsDetail from './SecondPeriodsDetail'
import formattedMessage from './languageModule'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import { Dismiss } from '@nexidigital/iconlibrary'
import './PaymentsDetail.scss'

const PaymentsDetail = ({ actions, open, tabSelected, groupByCardBrand, referredPeriod }) => {
  const { isSmallScreen } = useMobileDetect()

  // Nullsafe: verifica che groupByCardBrand e i suoi periodi esistano
  const periodOne = groupByCardBrand?.periodOne || []
  const periodOneTotals = groupByCardBrand?.periodOneTotals || {}
  const periodTwo = groupByCardBrand?.periodTwo || []
  const periodTwoTotals = groupByCardBrand?.periodTwoTotals || {}

  const tabData = [
    {
      label: formattedMessage.tabData1,
      content: <FirstPeriodDetail totals={periodOneTotals} transactions={periodOne} referredPeriod={referredPeriod} />
    },
    {
      label: formattedMessage.tabData2,
      content: <SecondPeriodsDetail totals={periodTwoTotals} transactions={periodTwo} referredPeriod={referredPeriod} />
    }
  ]
  return (
    <Toggle>
      <Dialog fullScreen open={open} className='paymentsDetailDialog'>
        <FlowTemplate
          flowBackground
          titleNavigation={formattedMessage.titleNavigation}
          iconCloseRight={<Dismiss size={isSmallScreen ? '24' : '20'} type='line' />}
          labelButtonRightNav={formattedMessage.close}
          onClickClose={() => actions.doClosePopup()}
          emptyPage
        >
          <sector className='paymentsDetail'>
            {tabSelected === 'TWO_PERIODS'
              ? (
                <PortalTabs merchant tabData={tabData} />
                )
              : (
                <FirstPeriodDetail totals={periodOneTotals} transactions={periodOne} referredPeriod={referredPeriod} />
                )}
          </sector>
        </FlowTemplate>
      </Dialog>
    </Toggle>
  )
}

PaymentsDetail.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  actions: PropTypes.object,
  /** This props is used to open the dialog */
  open: PropTypes.bool,
  /** This props is used to get the current tab of results */
  tabSelected: PropTypes.string,
  groupByCardBrand: PropTypes.object,
  referredPeriod: PropTypes.array
}

PaymentsDetail.defaultProps = {
  // Add here some default propTypes values
  actions: {},
  open: false,
  tabSelected: 'ONE_PERIOD',
  groupByCardBrand: {},
  referredPeriod: []
}

export default PaymentsDetail
